/**
 * @generated SignedSource<<58d5591758bd0a019f63b4a6047c6b6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReuseQuestions_feedback$data = {
  readonly id: string;
  readonly isAnonymous: boolean;
  readonly title: string;
  readonly " $fragmentType": "ReuseQuestions_feedback";
};
export type ReuseQuestions_feedback$key = {
  readonly " $data"?: ReuseQuestions_feedback$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReuseQuestions_feedback">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReuseQuestions_feedback",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAnonymous",
      "storageKey": null
    }
  ],
  "type": "FeedbackNode",
  "abstractKey": null
};

(node as any).hash = "365c3df64f6371a1987d017e5ad46ce5";

export default node;
